webpackJsonp([61],{

/***/ "3/kj":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-payment-details-with-card_21d018a217fff6c2a7ff29d5dbd377cb.html";

/***/ }),

/***/ "mhCG":
/***/ (function(module, exports, __webpack_require__) {

var SubscriptionPaymentDetailsWithCard = (function () {
    function SubscriptionPaymentDetailsWithCard() {
    }
    return SubscriptionPaymentDetailsWithCard;
}());
angular.module('animatronApp.SubscriptionPaymentDetailsWithCard', []).component('subscriptionPaymentDetailsWithCard', {
    bindings: {
        status: '<',
        type: '<',
        last4: '<',
        expires: '<',
        errorMessage: '<?',
        onChange: '&?',
        onDelete: '&?'
    },
    controller: SubscriptionPaymentDetailsWithCard,
    templateUrl: __webpack_require__("3/kj")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/61-40ecf89b893baa28ab63.min.js